'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { IconChevronLeft } from '../../../svg/icons/icon-chevron-left.js';

const MobileFullPageMenu = ({ children, onClick, open }) => (jsxs("div", { className: `flex-col ${open ? 'flex' : 'hidden'} w-full`, children: [jsx("div", { className: "flex w-full items-center border-b border-leland-gray-stroke pb-4", children: jsxs("button", { type: "button", className: "flex items-center gap-1 text-xl text-leland-gray-light", onClick: onClick, children: [jsx(IconChevronLeft, { className: "size-6" }), jsx("span", { children: "Back" })] }) }), children] }));

export { MobileFullPageMenu };
//# sourceMappingURL=mobile-full-page-menu.js.map
